import { useMutation, useQueryClient } from "@tanstack/react-query"
import api from "../../http"
import { useForBindingId } from '../../../forBinding'
import { CreateBindingConsultantPayload, CreateBindingFarmerPayload } from "@practium/features/users";
import { getApiErrorMessage, toApiError } from "../utils";

interface UseUpdateBindingUserParams {
    bindingType: number;
    id: string;
    data: CreateBindingFarmerPayload | CreateBindingConsultantPayload;
};


export const useUpdateBindingUser = () => {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();

    return useMutation({
        mutationFn: async ({ bindingType, id, data }: UseUpdateBindingUserParams) => {
            try {
                return (await api.put(`/binding-user/update/${bindingType}/${id}`, data, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar usuário');
            }
        },
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['binding-users'] });
            queryClient.setQueryData(
                ['binding-user', variables.bindingType, variables.id],
                (old: Record<string, unknown> | null) => {
                    if (!old || !data) return old;
                    return {
                        ...old,
                        name: data.name,
                        surName: data.surName,
                        email: data.email,
                        document: data.document,
                        phoneNumber: data.phoneNumber,
                        status: data.status,
                        canConnect: data.binding?.canConnect,
                    };
                }
            );
        },
        onError: (error) => {
            console.error('Erro ao atualizar usuário:', getApiErrorMessage(error, 'Erro ao atualizar usuário'))
        }
    })
}
